import React from "react";
import "./styles/Hero.css";
import siara from "../assets/siara.jpg";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>
          We Create Simple & Modern <span>Mobile Apps</span>
        </h1>

        <p>
          Siara Marketing PVT LTD helps turn your ideas into clean, easy-to-use
          mobile applications built with a focus on clarity, design, and smooth
          performance.
        </p>

        {/* <button className="hero-btn">Explore Apps</button> */}
      </div>
      <div className="hero-img">
        <img src={siara} alt="Siara Marketing PVT LTD" />
      </div>
    </section>
  );
}
